module.exports = __webpack_public_path__ + "static/media/iconActivityParascolaireActive.f672343c.svg";